<template>
  <gmaps-map style="height: 1000px" :options="mapOptions">
    <gmaps-heatmap v-if="loadReady" :items="locations" :maxIntensity="20" />
  </gmaps-map>
</template>

<script>
import { gmapsMap, gmapsHeatmap } from "x5-gmaps";

export default {
  name: "CustomerHeatMap",
  components: {
    gmapsMap,
    gmapsHeatmap,
  },
  data: () => ({
    loadReady: false,
    locations: [],
    locationspath: "/1.0/front/location/statistics/locations",
    mapOptions: {
      center: { lat: 62.24, lng: 25.72 },
      zoom: 6,
      mapTypeId: "hybrid",
    },
  }),
  mounted() {
    this.$http
      .get(this.locationspath)
      .then((response) => {
        console.log(response.status);
        if (response.status == 200) {
          this.locations = response.data.locations;
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        window.__logAxiosErrorIfDebug(error, {
          context: "CustomerHeatMap.vue - mounted",
        });
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>
